<template>
  <div class="container_">

    <div class="top-wrapper">

      <!-- 用户名: Username -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <span class="field-name">
          {{ $t('Username') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="username" :placeholder="$t('Please enter')" />
          <!-- <label v-if="!username" class="tips">{{ $t('Username: 3-25 chars, letters & numbers') }}</label> -->
        </div>
      </flex-line>

      <!-- 全名: Full Name -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <span class="field-name">
          {{ $t('Full Name') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" type="text" v-model="member_nickname" :placeholder="$t('Please enter')" />
        </div>
      </flex-line>

      <!-- 密码: Password -->
      <flex-line class="field-line input-wrapper" :show-border="true" :showPassword="showPassword"
        :toggleVisibility="toggleVisibility" :isPassword="true">
        <span class="field-name">
          {{ $t('Set Password') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" :type="showPassword ? 'text' : 'password'" v-model="password"
            :placeholder="$t('Please enter')" />
        </div>
      </flex-line>

      <!-- 再次输入密码: Re-enter Password -->
      <flex-line class="field-line input-wrapper" :show-border="true" :showPassword="showPassword2"
        :toggleVisibility="toggleVisibility2" :isPassword="true">
        <span class="field-name">
          {{ $t('Confirm Password') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" :type="showPassword2 ? 'text' : 'password'" v-model="confirmPassword"
            :placeholder="$t('Please enter')" />
          <!-- <label v-if="!confirmPassword" class="tips">{{ $t('6-20 digits/letters/symbols') }}</label> -->
        </div>
      </flex-line>

      <!-- 电话号码: Phone Number -->
      <!-- <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" type="text" v-model="member_mobile" :placeholder="$t('Phone Number')"
             />
        </div>
      </flex-line> -->
      <!-- 电子邮件: Email -->

      <flex-line class="field-line input-wrapper" :show-border="true">
        <span class="field-name">
          {{ $t('Email') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" type="text" v-model="member_email" :placeholder="$t('Please enter')" />
        </div>
      </flex-line>

      <!-- 邀请码: inviter -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <span class="field-name">
          {{ $t('Invitation code') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" type="text" v-model="inviterId" :placeholder="$t('Please enter')" />
        </div>
      </flex-line>

    </div>

    <div class="common-btn ds-button-large" @click="onSubmit">{{ $t('Sign Up') }}</div>
    <div class="link-wrapper">
      <!-- <span class="left-text" @click="goLogin">{{ $t('Login') }}</span> -->
    </div>

  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import { register } from '../../../api/memberRegister'
import { getSmsCaptcha, checkPictureCaptcha } from '../../../api/common'
import flexLine from '../../flexLine'
export default {
  name: 'RegisterByEmail',
  data() {
    return {
      username: '',
      member_nickname: '',
      password: '',
      confirmPassword: '',
      member_mobile: '',
      member_email: '',
      inviterId: '',
      isagree: false,
      aggrementUrl: '',
      showPassword: false,
      showPassword2: false,
    }
  },
  components: {
    flexLine
  },
  created: function () {
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId,
      config: state => state.config.config
    })
  },
  mounted() {
    this.inviterId = this.inviter_id || '' // 获取邀请人id
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    toggleVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleVisibility2() {
      this.showPassword2 = !this.showPassword2;
    },
    goBack() {
      this.$router.go(-1)
    },
    goProfile() {
      this.$router.go(-2)
    },
    goProfileAdd() {
      this.$router.push({ name: 'profileAdd' })
    },
    goLogin() {
      this.$router.push({ name: 'HomeMemberLogin' })
    },
    check() {
      let username = this.username;
      let password = this.password;
      let confirmPassword = this.confirmPassword;

      // if (this.isagree === false) {
      //   Toast(this.$t('Please check the user agreement'));
      //   return false;
      // }
      if (username.length === 0) {
        Toast(this.$t('Please enter a username with 3-25 characters'));
        return false;
      }
      if (username.length < 3 || username.length > 25) {
        Toast(this.$t('Please enter a username with 3-25 characters'));
        return false;
      }
      if (password.length === 0) {
        Toast(this.$t('Please enter a password'));
        return false;
      }
      if (password.length < 6 || password.length > 20) {
        Toast(this.$t('Please enter a password with 6-20 characters'));
        return false;
      }
      if (confirmPassword.length === 0) {
        Toast(this.$t('Please enter the confirm password'));
        return false;
      }
      if (password.length !== confirmPassword.length) {
        Toast(this.$t('The confirm password does not match the entered password'));
        return false;
      }
      if (password !== confirmPassword) {
        Toast(this.$t('The confirm password does not match the entered password'));
        return false;
      }
      // if (!this.member_nickname || !this.member_mobile || !this.member_email) {
      //   Toast(this.$t('Please complete the form'));
      //   return false;
      // }
      if (!this.member_nickname || !this.member_email || !this.inviterId) {
        Toast(this.$t('Please complete the form'));
        return false;
      }

      return true;
    },
    signup() {
      if (!this.check()) {
        return
      }
      Indicator.open()
      register(
        this.username,
        this.password,
        this.confirmPassword,
        this.inviterId,
        this.member_nickname,
        // this.member_mobile,
        this.member_email,
      ).then(
        response => {
          if (response.code === 10000) {
            Indicator.close()
            this.saveAuthInfo({ token: response.result.token, info: response.result.info })
            Toast(response.message || this.$t('succ'))

            setTimeout(() => {
              // this.$router.push({ name: 'MemberIndex' })
              this.$router.push({ name: 'HomeMemberLogin' })
            }, 500);
          } else {
            Indicator.close()
            Toast(response.message)
          }
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    onSubmit() {
      this.signup()
    },
    onAgreement() {
      this.$router.push({
        name: 'HomeDocument',
        query: { type: '' }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.bottom-btn {
  width: 100%;
  // position: fixed;
  // bottom: 0;
  // right: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.4rem;
  box-sizing: border-box;

  .retrieve-item {
    font-size: 1.4rem;
    font-weight: 600;
  }

}

.ds-button-large {
  width: 80%;
  margin: 1rem auto 0;
  background: #E7010C;
  padding: .2rem;
}

.container_ {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  //background-color: $primaryColor;
  .input-wrapper {
    font-size: $subFontSize;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    align-items: center;
    background-color: #fff;
    // height: 2.2rem;
    // padding-left: 0.5rem;

    img {
      height: 1.75rem;
      width: auto;
      margin: 0;
      padding: 0;
    }

    input {
      flex: 1;
    }

    .bottom-input {
      border-bottom-width: 0;
    }
  }

  .input-wrapper {
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    align-items: center;
    background-color: #fff;
    // height: 2.2rem;
    // padding-left: 0.5rem;

    flex-direction: column;
    align-items: flex-start;
    margin: .4rem 0;

    .field-name {
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      margin: .5rem 0;
      position: relative;

      &::after {
        content: '*';
        color: red;
        position: absolute;
        top: 50%;
        right: -0.5rem;
        transform: translateY(-50%);
      }
    }

    input {
      box-sizing: border-box;
      flex: 1;
      font-size: $subFontSize;
      flex: 1;
      // width: 14.5rem;
      width: 100%;
      text-align: left;
      // border: 1px solid #cccccc;
      padding: .9rem;
      border-radius: .4rem;
      background: #FAFAFA;
      border-radius: 5px 5px 5px 5px;
    }

    .bottom-input {
      border-bottom-width: 0;
    }

    .field-line-right {
      width: 100%;
      position: relative;
    }

    ::v-deep(.right) {
      width: 100%;
    }
  }

  .link-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;

    span {
      font-size: $subFontSize;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .left-text {
      padding: 0 0.5rem;
      color: $descTextColor;
    }

    .right-text {
      color: $primaryColor;
    }
  }
}

.top-wrapper {
  margin: 0 1rem;
}

.bottom-wrapper {
  margin-top: 0.5rem;
}

.tips {
  color: $descTextColor;
  font-size: $fontSize;
  white-space: nowrap;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -.3rem;
}

.countdown {
  min-width: 4rem;
  margin-right: 0.5rem;
}

.field-line-right {
  position: relative;
}

.field-input {
  text-align: left !important;
}

.isagree {
  width: .8rem;
  height: .8rem;
}
</style>
